/** Job config wizard / expert step identifiers (aligned with backend {@code expertHiddenSteps}). */
export enum StepTypeEnum {
  BOOKLET_TYLE = 'BOOKLET_TYLE',
  QUANTITIES = 'QUANTITIES',
  PAGE_COUNT = 'PAGE_COUNT',
  PLACEMENT_STAPLES = 'PLACEMENT_STAPLES',
  SIZE_ORIENTATION = 'SIZE_ORIENTATION',
  JOB_OPTIONS = 'JOB_OPTIONS',
  PART_ACTION = 'PART_ACTION',
  PART_PAPER = 'PART_PAPER',
  PART_PRINTING = 'PART_PRINTING',
  PART_OPTIONS = 'PART_OPTIONS',
  SERVICES = 'SERVICES',
  ARRIVAL_DATE = 'ARRIVAL_DATE',
  ADD_FILES = 'ADD_FILES',
  VIEW_QUOTE = 'VIEW_QUOTE',
  COMPARISON = 'COMPARISON',
}
